import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShareLight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.3609 8.40464C14.5237 8.26515 14.605 8.1954 14.6348 8.1124C14.661 8.03955 14.661 7.95986 14.6348 7.88702C14.605 7.80402 14.5237 7.73427 14.3609 7.59477L8.71376 2.75435C8.4336 2.51422 8.29353 2.39416 8.17493 2.39122C8.07186 2.38866 7.97341 2.43394 7.90828 2.51386C7.83333 2.60582 7.83333 2.79031 7.83333 3.15929V6.02279C6.41021 6.27176 5.10773 6.99288 4.13981 8.07562C3.08455 9.25605 2.50082 10.7837 2.5 12.367V12.775C3.19956 11.9323 4.073 11.2507 5.06051 10.777C5.93113 10.3593 6.87228 10.1119 7.83333 10.0467V12.8401C7.83333 13.2091 7.83333 13.3936 7.90828 13.4856C7.97341 13.5655 8.07186 13.6108 8.17493 13.6082C8.29353 13.6053 8.4336 13.4852 8.71376 13.2451L14.3609 8.40464Z",
		stroke: "#808080",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShareLight;
